export default __webpack_public_path__ + "static/media/angers8.196bcd27.jpg";